import React from 'react';
import BaseScadaNode from './BaseScadaNode';

export function VBlenderSVG({ config = {}, width = 90, height = 75, liveValues = {} }) {
    const running = parseFloat(liveValues.state ?? 1) >= parseFloat(config.threshold ?? 0.5);
    const hasError = liveValues.error === 1 || liveValues.error === true ||
        liveValues.error === '1' || liveValues.error === 'true';
    const statusColor = hasError ? '#EF4444' : running ? '#22C55E' : '#64748B';
    const fillColor = config.fill_color || '#94A3B8';

    const cx = width / 2;
    const tipY = height - 14;      // bottom tip of V
    const armW = 16;               // arm thickness
    const armEndY = 10;            // top of arms
    const leftArmX = 6;           // top-left x of left arm
    const rightArmX = width - 6;  // top-right x of right arm

    // V outline path (outer then inner)
    const outerPath = `M${leftArmX},${armEndY} L${cx - armW / 2},${tipY} L${cx + armW / 2},${tipY} L${rightArmX},${armEndY} L${rightArmX - armW},${armEndY} L${cx},${tipY - armW * 0.7} L${leftArmX + armW},${armEndY} Z`;

    // Discharge stub
    const stubX = cx - 4;
    const stubW = 8;
    const stubH = 8;

    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: 'block' }}>
            {/* Inlet stubs at top of each arm */}
            <rect x={leftArmX + 3} y={0} width={armW - 6} height={armEndY} rx={2} fill="#475569" />
            <rect x={rightArmX - armW + 3} y={0} width={armW - 6} height={armEndY} rx={2} fill="#475569" />

            {/* V-blender body group — rotation animation when running */}
            <g>
                {/* Outer shell */}
                <path d={outerPath} fill="#1E293B" stroke={statusColor} strokeWidth={2}
                    strokeLinejoin="round" />

                {/* Fill material inside (partial fill) */}
                {running && (
                    <clipPath id={`vbClip_${width}_${height}`}>
                        <path d={outerPath} />
                    </clipPath>
                )}
                {running && (
                    <rect x={leftArmX} y={tipY - (tipY - armEndY) * 0.55} width={width - 12} height={(tipY - armEndY) * 0.55 + armW}
                        fill={fillColor} opacity={0.3}
                        clipPath={`url(#vbClip_${width}_${height})`} />
                )}

                {/* "V" label */}
                <text x={cx} y={tipY - 16} textAnchor="middle"
                    fill={statusColor} fontSize={11} fontWeight="bold">V</text>

                {/* Status dot */}
                <circle cx={rightArmX - 8} cy={armEndY + 8} r={4}
                    fill={statusColor} stroke="#0F172A" strokeWidth={1} />

                {/* Rotation animation */}
                {running && (
                    <animateTransform
                        attributeName="transform"
                        type="rotate"
                        from={`0 ${cx} ${(armEndY + tipY) / 2}`}
                        to={`360 ${cx} ${(armEndY + tipY) / 2}`}
                        dur="4s"
                        repeatCount="indefinite"
                    />
                )}
            </g>

            {/* Discharge stub (outside rotating group) */}
            <rect x={stubX} y={tipY} width={stubW} height={stubH} rx={2} fill="#475569" />

            {/* Error flash */}
            {hasError && (
                <rect x={2} y={2} width={width - 4} height={height - 4} rx={4}
                    fill="none" stroke="#EF4444" strokeWidth={2}>
                    <animate attributeName="stroke-opacity" values="1;0;1" dur="0.6s" repeatCount="indefinite" />
                </rect>
            )}
        </svg>
    );
}

export default function VBlenderNode(props) {
    const { data } = props;
    const w = data?.width || 90;
    const h = data?.height || 75;
    return (
        <BaseScadaNode {...props}>
            <VBlenderSVG config={data?.config} width={w} height={h} liveValues={data?.liveValues || {}} />
            {data?.label && (
                <div style={{ textAlign: 'center', fontSize: 10, color: '#94A3B8', marginTop: 2,
                    overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                    {data.label}
                </div>
            )}
        </BaseScadaNode>
    );
}
